var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app_layout"},[_c('AppHeader'),_c('div',{staticClass:"content"},[_c('router-view')],1),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }